import { ComponentProps, useContext } from "react";
import { DrawerSelectContext } from "../drawer-select.context";
import { DrawerSelectContentInline } from "./drawer-select-content-inline";
import { DrawerSelectContentModal } from "./drawer-select-content-modal";

export type DrawerSelectContentProps = ComponentProps<"div"> & {
  stickyFooter?: boolean;
};

export function DrawerSelectContent({ ...props }: DrawerSelectContentProps) {
  const { variant, isOpen } = useContext(DrawerSelectContext);

  if (!isOpen) {
    return null;
  }

  if (variant === "modal") {
    return <DrawerSelectContentModal {...props} />;
  }

  return <DrawerSelectContentInline {...props} />;
}
